// @ts-nocheck
import React, { useState } from 'react';
import Form from 'react-bootstrap/Form';
import { useTranslation } from 'react-i18next';
import useLookupNationality from '@hooks/Lookups/use-Lookup-Nationality';
import { useDispatch } from 'react-redux';
import { useFormik } from 'formik';
import { getLocations, insertLocation } from '@store/HR/HRSetting/locationSlice';
import { formLocation } from '../../../ValidationForm/validationSchema';
import useGetOrganizations from '@hooks/HR/use-get-organizations';
import CustomAlert from '@components/Shared/Alert/CustomAlert';
import { Card, CardBody } from '@components/card/card';
// import Map from '@components/Shared/Map/Map';
import Map2 from '@components/Shared/Map2/Map2';

const AddLocation = () => {
  //////////////////////////// State  for Map
  const [center, setCenter] = useState({ lat: 24.7135517, lng: 46.6752957 });
  const [lat, setLat] = useState(center.lat);
  const [lng, setLng] = useState(center.lng);
  //////////////////////////// State  for Map
  // console.log(lng);

  //// Get Organizations
  const { Organizations } = useGetOrganizations();
  // const dataOrg = Organizations?.filter((f) => f.type === "130");
  ///////////////////
  const { NATIONALITY } = useLookupNationality();
  const { t, i18n } = useTranslation();

  const dispatch = useDispatch();
  const formik = useFormik({
    initialValues: {
      name: '',
      name2: '',
      businessGroupId: '',
      description: '',
      shipToLocationId: 0,
      shipToSiteFlag: false,
      receivingSiteFlag: false,
      billToSiteFlag: false,
      country: '',
      addressLine: '',
      townOrCity: '',
      postalCode: '',
      region: '',
      telephoneNumber: '',
      latitude: lat,
      longitude: lng
    },

    validationSchema: formLocation(t),

    onSubmit: (values, { resetForm }) => {
      values.latitude = lat.toString();
      values.longitude = lng.toString();

      dispatch(
        insertLocation({
          name: values.name,
          name2: values.name2,
          // businessGroupId: values.businessGroupId,
          businessGroupId: null,
          description: values.description,
          shipsToLocationId: null, /// نحتاجها في المبيعات
          shipToSiteFlag: values.shipToSiteFlag, // نحتاجها في المبيعات
          receivingSiteFlag: values.receivingSiteFlag, // نحتاجها في المبيعات
          billToSiteFlag: values.billToSiteFlag, // نحتاجها في المبيعات
          country: values.country,
          addressLine: values.addressLine,
          townOrCity: values.townOrCity,
          postalCode: values.postalCode,
          region: values.region,
          telephoneNumber: values.telephoneNumber,
          latitude: values.latitude,
          longitude: values.longitude
        })
      )
        .unwrap()
        .then(() => {
          CustomAlert({ action: 'Add' });
          dispatch(getLocations());
          document.getElementById('closeModalLocation').click();
        })
        .catch(error => {
          formik.setSubmitting(false);
          CustomAlert({ action: 'Error' });
        });
    }
  });

  return (
    <Form onSubmit={formik.handleSubmit}>
      <div className='mb-4'>
        <h6 className=''>
          <i className='fa-solid fa-circle-info text-theme me-2'></i>
          المعلومات الأساسية
        </h6>
        <hr />

        <div className='row'>
          <div className='col-xl-6'>
            <div className='form-group mb-3'>
              <label className='form-label'>{t('LocalName')}</label>
              <Form.Control
                className='form-control'
                type='text'
                autoComplete='off'
                name='name2'
                onChange={formik.handleChange}
                value={formik.values.name2}
                isInvalid={formik.touched.name2 && formik.errors.name2}
              />
              <Form.Control.Feedback type='invalid'>{formik.errors.name2}</Form.Control.Feedback>
            </div>
          </div>

          <div className='col-xl-6'>
            <div className='form-group mb-3'>
              <label className='form-label'>{t('GlobalName')}</label>
              <Form.Control
                className='form-control'
                type='text'
                autoComplete='off'
                name='name'
                onChange={formik.handleChange}
                value={formik.values.name}
                isInvalid={formik.touched.name && formik.errors.name}
              />
              <Form.Control.Feedback type='invalid'>{formik.errors.name}</Form.Control.Feedback>
            </div>
          </div>
          {/* <div className='col-xl-4'>
            <div className='form-group mb-3'>
              <label className='form-label'>{t('Organization')}</label>
              <Form.Select
                className='form-select'
                name='businessGroupId'
                onChange={formik.handleChange}
                value={formik.values.businessGroupId}
                isInvalid={formik.touched.businessGroupId && formik.errors.businessGroupId}
              >
                <option key={null}>{i18n.language === 'ar' ? 'إختر' : 'Choose'}</option>
                {Organizations &&
                  Organizations?.map((item, idx) => (
                    <option key={++idx} value={item.id}>
                      {i18n.language === 'ar' ? item.name2 : item.name}
                    </option>
                  ))}
              </Form.Select>
              <Form.Control.Feedback type='invalid'>
                {formik.errors.businessGroupId}
              </Form.Control.Feedback>
            </div>
          </div> */}
        </div>
      </div>
      <div className='mb-4'>
        <h6 className=''>
          <i className='fa-solid fa-address-book text-theme me-2'></i>
          العنوان ومعلومات الإتصـال
        </h6>
        <hr />

        <div className='row'>
          <div className='col-xl-3'>
            <div className='form-group mb-3'>
              <label className='form-label'>{t('Country')}</label>
              <Form.Select
                className='form-select'
                name='country'
                onChange={formik.handleChange}
                value={formik.values.country}
                isInvalid={formik.touched.country && formik.errors.country}
              >
                <option key={null}>{i18n.language === 'ar' ? 'إختر' : 'Choose'}</option>
                {NATIONALITY?.map((item, idx) =>
                  item.list?.map(list => (
                    <option key={++idx} value={list.lookupCode}>
                      {i18n.language === 'en' ? list.meaning : list.meaning2}
                    </option>
                  ))
                )}
              </Form.Select>
            </div>
          </div>

          <div className='col-xl-3'>
            <div className='form-group mb-3'>
              <label className='form-label'>{t('City')}</label>
              <Form.Control
                className='form-control'
                type='text'
                autoComplete='off'
                name='townOrCity'
                onChange={formik.handleChange}
                value={formik.values.townOrCity}
                isInvalid={formik.touched.townOrCity && formik.errors.townOrCity}
              />
            </div>
          </div>

          <div className='col-xl-3'>
            <div className='form-group mb-3'>
              <label className='form-label'>{t('Address')}</label>
              <Form.Control
                className='form-control'
                type='text'
                autoComplete='off'
                name='addressLine'
                onChange={formik.handleChange}
                value={formik.values.addressLine}
                isInvalid={formik.touched.addressLine && formik.errors.addressLine}
              />
            </div>
          </div>

          <div className='col-xl-3'>
            <div className='form-group mb-3'>
              <label className='form-label'>{t('PostalCode')}</label>
              <Form.Control
                className='form-control'
                type='text'
                autoComplete='off'
                name='postalCode'
                onChange={formik.handleChange}
                value={formik.values.postalCode}
                isInvalid={formik.touched.postalCode && formik.errors.postalCode}
              />
            </div>
          </div>
          {/* <div className='col-xl-4'>
            <div className='form-group mb-3'>
              <label className='form-label'>{t('Region')}</label>
              <Form.Control
                className='form-control'
                type='text'
                autoComplete='off'
                name='region'
                onChange={formik.handleChange}
                value={formik.values.region}
                isInvalid={formik.touched.region && formik.errors.region}
              />
            </div>
          </div> */}
          <div className='col-xl-3'>
            <div className='form-group mb-3'>
              <label className='form-label'>{t('MobileNumber')}</label>
              <Form.Control
                className='form-control'
                type='text'
                autoComplete='off'
                // placeholder="الهوية"
                name='telephoneNumber'
                onChange={formik.handleChange}
                value={formik.values.telephoneNumber}
                isInvalid={formik.touched.telephoneNumber && formik.errors.telephoneNumber}
              />
              {/* <Form.Control.Feedback type="invalid">
            {formik.errors.NATIONAL_IDENTIFIER}
          </Form.Control.Feedback> */}
            </div>
          </div>
          <div className='col-xl-9'>
            <div className='form-group mb-3'>
              <label className='form-label'>{t('Note')}</label>
              <Form.Control
                className='form-control'
                as='textarea'
                rows={1}
                name='description'
                onChange={formik.handleChange}
                value={formik.values.description}
              />

              <div></div>
            </div>
          </div>
        </div>
      </div>

      {/* <div className='mb-4'>
        <h6 className=''>
          <i className='fas fa-lg fa-fw me-2 fa fa-info-circle text-theme'></i>
          خيارات إضافية
        </h6>
        <hr />

        <div className='row'>
          <div className='col-xl-4 text-center'>
            <div className='form-group mb-3'>
              <label className='form-label'>يُشحن لـه</label>
              <Form.Check
                style={{ margin: '10px 40px' }}
                type='checkbox'
                name='shipToSiteFlag'
                onChange={formik.handleChange}
                value={formik.values.shipToSiteFlag}
              />
            </div>
          </div>

          <div className='col-xl-4 text-center'>
            <div className='form-group mb-3'>
              <label className='form-label'>يُفوتر لـه</label>
              <Form.Check
                style={{ margin: '10px 40px' }}
                type='checkbox'
                name='billToSiteFlag'
                onChange={formik.handleChange}
                value={formik.values.billToSiteFlag}
              />
            </div>
          </div>

          <div className='col-xl-4 text-center'>
            <div className='form-group mb-3'>
              <label className='form-label'>يستقبل بضاعة</label>
              <Form.Check
                style={{ margin: '10px 40px' }}
                type='checkbox'
                name='receivingSiteFlag'
                onChange={formik.handleChange}
                value={formik.values.receivingSiteFlag}
              />
            </div>
          </div>
        </div>
      </div> */}

      {/* <div className='mb-4'>
        <h6 className=''>
          <i className='fas fa-lg fa-fw me-2 fa fa-info-circle text-theme'></i>
          الموقع الجغرافي
        </h6>
        <hr />

        <div>
          <div className='row'>
            <div className='col-xl-4'>
              <div className='form-group mb-3'>
                <label className='form-label'>{t('Latitude')}</label>

                <Form.Control
                  className='form-control'
                  type='text'
                  autoComplete='off'
                  value={lat}
                  name='latitude'
                  onChange={e => setLat(parseFloat(e.target.value))}
                  readOnly
                  isInvalid={formik.errors.latitude}
                />
              </div>
            </div>

            <div className='col-xl-4'>
              <div className='form-group mb-3'>
                <label className='form-label'>{t('Longitude')}</label>
                <Form.Control
                  className='form-control'
                  type='text'
                  autoComplete='off'
                  value={lng}
                  onChange={e => setLng(parseFloat(e.target.value))}
                  name='longitude'
                  readOnly
                  isInvalid={!!formik.errors.longitude}
                />
              </div>
            </div>
          </div>
          <div style={{ height: '250px' }}>
            <Map2 />
          </div>
        </div>
      </div> */}

      {/* <div className='mb-4 p-4 rounded-xl shadow-md border border-gray-200 bg-white'>
        <h6 className='flex items-center text-lg font-semibold mb-3 text-gray-700'>
          <i className='fas fa-lg fa-fw me-2 fa fa-info-circle text-theme'></i>
          الموقع الجغرافي
        </h6>
        <hr className='mb-4' />

        <div className='row'>
           <div className='col-xl-2'>
            <div className='form-group mb-3'>
              <label className='form-label'>{t('Latitude')}</label>
              <Form.Control
                className='form-control'
                type='text'
                autoComplete='off'
                value={lat}
                name='latitude'
                onChange={e => setLat(parseFloat(e.target.value))}
                readOnly
                isInvalid={formik.errors.latitude}
              />
            </div>

            <div className='form-group mb-3'>
              <label className='form-label'>{t('Longitude')}</label>
              <Form.Control
                className='form-control'
                type='text'
                autoComplete='off'
                value={lng}
                onChange={e => setLng(parseFloat(e.target.value))}
                name='longitude'
                readOnly
                isInvalid={!!formik.errors.longitude}
              />
            </div>
          </div>

           <div className='col-xl-10'>
            <div style={{ height: '250px' }}>
              <Map2 />
            </div>
          </div>
        </div>
      </div> */}

      <div className='mb-4'>
        {/* Section Header */}
        <div className='d-flex align-items-center mb-3'>
          <i className='fas fa-map-marker-alt fa-lg me-2 text-theme'></i>
          <h6 className='m-0'>الموقع الجغرافي</h6>
        </div>
        <hr className='mt-1 mb-4' />

        {/* Coordinates Input */}
        <div className='row g-3 mb-3'>
          <div className='col-md-6'>
            <div className='input-group flex-nowrap'>
              <span className='input-group-text fw-bold'>{t('Longitude')}</span>
              <Form.Control
                type='text'
                className='form-control'
                id='longitudeInput'
                value={lng}
                onChange={e => setLng(parseFloat(e.target.value))}
                readOnly
                isInvalid={!!formik.errors.longitude}
              />
            </div>
          </div>
          <div className='col-md-6'>
            <div className='input-group flex-nowrap'>
              <span className='input-group-text fw-bold'>{t('Latitude')}</span>
              <Form.Control
                type='text'
                className='form-control'
                id='latitudeInput'
                value={lat}
                onChange={e => setLat(parseFloat(e.target.value))}
                readOnly
                isInvalid={formik.errors.latitude}
              />
            </div>
          </div>

          {/* <div className='col-md-6'>
            <div className='form-floating'>
              <Form.Control
                type='text'
                className='form-control'
                id='latitudeInput'
                value={lat}
                onChange={e => setLat(parseFloat(e.target.value))}
                readOnly
                isInvalid={formik.errors.latitude}
              />
              <label htmlFor='latitudeInput'>{t('Latitude')}</label>
              {formik.errors.latitude && (
                <div className='invalid-feedback d-block'>{formik.errors.latitude}</div>
              )}
            </div>
          </div>

          <div className='col-md-6'>
            <div className='form-floating'>
              <Form.Control
                type='text'
                className='form-control'
                id='longitudeInput'
                value={lng}
                onChange={e => setLng(parseFloat(e.target.value))}
                readOnly
                isInvalid={!!formik.errors.longitude}
              />
              <label htmlFor='longitudeInput'>{t('Longitude')}</label>
              {formik.errors.longitude && (
                <div className='invalid-feedback d-block'>{formik.errors.longitude}</div>
              )}
            </div>
          </div> */}
        </div>

        {/* Interactive Map */}
        <div className='border rounded p-2 mb-3' style={{ height: '250px' }}>
          <div className='h-100'>
            <Map2
              center={center}
              onMarkerMove={(newLat, newLng) => {
                setLat(newLat);
                setLng(newLng);
              }}
            />
          </div>
        </div>

        {/* Help Text */}
        <div className='text-muted small'>
          <i className='fas fa-info-circle me-2'></i>
          يمكنك تحديد الموقع إما عن طريق إدخال الإحداثيات أو النقر على الخريطة
        </div>
      </div>

      <hr />

      <div className='text-center'>
        <div className='d-flex justify-content-between gap-2'>
          <button disabled={formik.isSubmitting} type='submit' className='btn btn-lg btn-theme mb-1 w-100'>
            {formik.isSubmitting ? (
              <div className='spinner-border spinner-border-sm me-2'></div>
            ) : (
              <i className='fas fa-save fa-lg fa-fw me-2'></i>
            )}
            {t('Add')}
          </button>
          <button
            type='button'
            className='btn btn-lg  btn-default mb-1 w-100'
            data-bs-dismiss='modal'
            id='closeModalJob'
          >
            <i className='fa fa-power-off fa-fw me-1'></i> {t('Cancel')}
          </button>
        </div>
      </div>
    </Form>
  );
};

export default AddLocation;
